export default __webpack_public_path__ + "static/media/image1.1eafa64e8ac4f4df0cb99ef22f03e53e.png";